import * as DocumentPicker from "expo-document-picker"

export const documentPicker = async () => {
    const result = await DocumentPicker.getDocumentAsync({
        type: ["application/pdf", "image/*"],
    })
    if (result.canceled) return null
    const asset = result.assets?.[0]
    if (!asset?.uri) return null
    // The type travels with the address: on the web that address is a `blob:`
    // URL, which cannot tell a PDF from an image.
    return { uri: asset.uri, name: asset.name, mimeType: asset.mimeType }
}
